import OrgDetaljerPage from '../OrgDetaljer/OrgDetaljerPage'
export default function SelgereDetaljerPage() { return <OrgDetaljerPage side="selgere" /> }
